import http from '@core/fetch'

export default {
  // 检测是否需要竖图弹窗
  isEditVerticalImage: body =>
    http('/hps/admin/localServerMerchant/work/warnStatusText', {
      body
    }),
  merchantList: body =>
    http('/hps/mainAdmin/localServerMerchant/fourRole/topMerchantList', {
      body,
      expect: []
    })
}
